import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route, useLocation, Navigate } from "react-router-dom";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import ScrollToTop from "./components/ScrollToTop";
import ScrollToTopButton from "./components/ScrollToTopButton";
import CookieBanner from "./components/CookieBanner";
import Home from "./pages/Home";
import Association from "./pages/Association";
import HowItWorks from "./pages/HowItWorks";
import Locations from "./pages/Locations";
import Impact from "./pages/Impact";
import Blog from "./pages/Blog";
import BlogPost from "./pages/BlogPost";
import Donate from "./pages/Donate";
import SupportUs from "./pages/SupportUs";
import Contact from "./pages/Contact";
import LegalPage from "./pages/LegalPage";
import "./styles/legal-page.css";
import AdminLogin from "./pages/admin/AdminLogin";
import AdminLayout from "./pages/admin/AdminLayout";
import AdminDashboard from "./pages/admin/AdminDashboard";
import AdminContacts from "./pages/admin/AdminContacts";
import AdminDonations from "./pages/admin/AdminDonations";
import AdminArticles from "./pages/admin/AdminArticles";
import AdminArticleEdit from "./pages/admin/AdminArticleEdit";
import AdminContentHub from "./pages/admin/AdminContentHub";
import AdminContentSection from "./pages/admin/AdminContentSection";
import { Toaster } from "./components/ui/toaster";
import { ContentProvider } from "./contexts/ContentContext";

function Shell() {
  const { pathname } = useLocation();
  const isAdmin = pathname.startsWith('/admin');
  return (
    <>
      <ScrollToTop />
      {!isAdmin && <Navbar />}
      <main className="min-h-screen">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/association" element={<Association />} />
          <Route path="/comment-ca-marche" element={<Navigate to="/premierkiosqueàeauàpau" replace />} />
          <Route path="/premierkiosqueàeauàpau" element={<HowItWorks />} />
          <Route path="/localisations" element={<Locations />} />
          <Route path="/impact-ecologique" element={<Impact />} />
          <Route path="/blog" element={<Blog />} />
          <Route path="/blog/:slug" element={<BlogPost />} />
          <Route path="/soutenir" element={<Donate />} />
          <Route path="/je-soutiens" element={<SupportUs />} />
          <Route path="/contact" element={<Contact />} />

          <Route path="/mentions-legales" element={<LegalPage pageKey="mentions" />} />
          <Route path="/politique-confidentialite" element={<LegalPage pageKey="privacy" />} />
          <Route path="/politique-cookies" element={<LegalPage pageKey="cookies" />} />

          <Route path="/admin/login" element={<AdminLogin />} />
          <Route path="/admin" element={<AdminLayout />}>
            <Route index element={<AdminDashboard />} />
            <Route path="contacts" element={<AdminContacts />} />
            <Route path="donations" element={<AdminDonations />} />
            <Route path="articles" element={<AdminArticles />} />
            <Route path="articles/new" element={<AdminArticleEdit />} />
            <Route path="articles/:id" element={<AdminArticleEdit />} />
            <Route path="content" element={<AdminContentHub />} />
            <Route path="content/:section" element={<AdminContentSection />} />
          </Route>
        </Routes>
      </main>
      {!isAdmin && <Footer />}
      {!isAdmin && <ScrollToTopButton />}
      {!isAdmin && <CookieBanner />}
    </>
  );
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <ContentProvider>
          <Shell />
          <Toaster />
        </ContentProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
